"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipCoverDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
let OpportunityPlacementSlipCoverDetail = class OpportunityPlacementSlipCoverDetail {
};
exports.OpportunityPlacementSlipCoverDetail = OpportunityPlacementSlipCoverDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_template_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "coverTemplateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipCoverDetail.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_response", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipCoverDetail.prototype, "coverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipCoverDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPlacementSlipCoverDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPlacementSlipCoverDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placement) => placement.coverDetails),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration !== "undefined" && opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration) === "function" ? _c : Object)
], OpportunityPlacementSlipCoverDetail.prototype, "placementSlip", void 0);
exports.OpportunityPlacementSlipCoverDetail = OpportunityPlacementSlipCoverDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_cover_detail")
], OpportunityPlacementSlipCoverDetail);
